<template>
    <b-container 
        class="content" 
        fluid 
        v-if="isLoaded"
    >
        <div class="table-responsive scroll-content">
            <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em;border-collapse: separate;border-spacing:0;">
                <thead style="position: sticky;background-color: white;top: 0px;z-index:2">
                <tr>
                    <th :colspan="6" >
                        <div class="tableBodyCell insert-row" style="align:center;left: 0; right: 0; margin:auto;border-bottom: 0px"
                        v-if="!insertMode && canEditGoals"
                        @click="insertRow($event.target)">
                            <span><i class="fas fa-plus-circle fa-2x"></i></span>
                        </div>
                    </th>
                    <th :colspan="1">
                        <div style="width: 100px;float:right;">
                            <b-form-select v-model="yearSelection" :options="yearChoices" class="gray-select" style="height:41px !important;"/>
                        </div>
                    </th>
                </tr>
                <tr>
                    <th>{{ $t('dataTypeColumn') }}</th>
                    <th>{{ $t('locations') }}</th>
                    <th>{{ $t('startYearColumn') }}</th>
                    <th>{{ $t('endYearColumn') }}</th> 
                    <th>{{ $t('goalTypeColumn') }}</th>
                    <th>{{ $t('goalRatioColumn') }}</th>
                    <th v-show="canEditGoals" id="goal-last-column" style="width: 9em;"></th>
                </tr>
                </thead>
                <tbody>
                <!-- Update item view -->
                <tr v-for="goal in filteredGoals" @keyup.esc="bindItems(rawItems)">
                    <td>
                        <div class="tableBodyCell">
                            <div :title="$t(goal.dataTypeId.name)">
                                {{ $t(goal.dataTypeId.name) }} ({{$t(goal.unit.name)}})
                            </div>
                        </div>
                    </td>
                    <!-- start and end year view -->
                    <td>
                        <div class="tableBodyCell">
                            <div :title="$t(goal.dataTypeId.name)">
                                {{ getTopNLocation(goal) }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="tableBodyCell">
                            {{ (goal.startYear.editedValue ? goal.startYear.editedValue : '-')}}
                        </div>
                    </td>
                    <td>
                        <div class="tableBodyCell">
                            {{ (goal.endYear.editedValue ? goal.endYear.editedValue : '-')}}
                        </div>
                    </td>                    
                    <td>
                        <div class="tableBodyCell">
                            {{ directionValueToText(goal.direction.value) }}
                        </div>
                    </td>
                    <td>
                        <div class="tableBodyCell">
                            <template v-if="goal.direction.editedValue === 0">
                                -
                            </template>
                            <template v-else>
                                {{goal.valueR.value}}
                            </template>
                        </div>
                    </td>
                    <td v-show="canEditGoals" :style="{width: lastColumnWidth}" class="edit-column" style="position:static;">
                        <div class="tableBodyCell">
                            <div @click="makeRowEditable($event.target,goal.id)" style="color: #8888; cursor: pointer">
                                <i class="fas fa-edit"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </b-container>
</template>

<script>
import _ from 'lodash';
import globalFilters from '../../filters';
import uuid from 'uuid/v4';

export default {
    name: 'AdminGoal',
    data() {
        return {
            selectedSite: null,
            canEditGoals: this.$store.state.user.permissions.canCreateGlobalGoals,
            isLoaded: false, // Toggles page loading
            goals: [],
            filteredGoals: [],
            err: null,
            rawItems: [], // Original goal object array
            units: [],
            dataTypes: [1, 2],
            tempItem: {}, // Temporary object used for inserts
            yearSelection: `${new Date().getFullYear()}`,
            goalTypes: [
                {
                    value: 0,
                    text: this.$t('currentSituation')
                },
                {
                    value: -1,
                    text: this.$t('decrease')
                },
                {
                    value: 1,
                    text: this.$t('raise')
                }
            ],
            yearChoices: [
                {
                    value: `${new Date().getFullYear() - 5}`,
                    text: `${new Date().getFullYear() - 5}`
                },
                {
                    value: `${new Date().getFullYear() - 4}`,
                    text: `${new Date().getFullYear() - 4}`
                },
                {
                    value: `${new Date().getFullYear() - 3}`,
                    text: `${new Date().getFullYear() - 3}`
                },
                {
                    value: `${new Date().getFullYear() - 2}`,
                    text: `${new Date().getFullYear() - 2}`
                },
                {
                    value: `${new Date().getFullYear() - 1}`,
                    text: `${new Date().getFullYear() - 1}`
                },
                {
                    value: `${new Date().getFullYear()}`,
                    text: `${new Date().getFullYear()}`
                },
                {
                    value: `${new Date().getFullYear() + 1}`,
                    text: `${new Date().getFullYear() + 1}`
                },
                {
                    value: `${new Date().getFullYear() + 2}`,
                    text: `${new Date().getFullYear() + 2}`
                },
                {
                    value: `${new Date().getFullYear() + 3}`,
                    text: `${new Date().getFullYear() + 3}`
                },
                {
                    value: `${new Date().getFullYear() + 4}`,
                    text: `${new Date().getFullYear() + 4}`
                },
                {
                    value: `${new Date().getFullYear() + 5}`,
                    text: `${new Date().getFullYear() + 5}`
                }
            ],
            insertMode: false,
            inProgress: false,
            lastColumnWidth: '140px'
        };
    },

    methods: {
        directionValueToText(val) {
            if (val === 0) {
                return this.$t('currentSituation');
            } else if (val === -1) {
                return this.$t('decrease');
            } else {
                return this.$t('raise');
            }
        },

        getTopNLocation(goal){
            let allIds = goal.goalSites.editedValue;
            if(_.includes(allIds, 'All')){
                return this.$t('AllLocations');
            }else{
                let regionIds = _.filter(allIds, o=>o.split('-')[0] == 'region');
                let cityIds = _.filter(allIds, o=>o.split('-')[0] == 'city');
                let siteIds = _.difference(allIds, regionIds);
                siteIds = _.difference(siteIds, cityIds);
                let locationNames = [];

                _.each(regionIds.slice(0,3), region=>{
                    let regionId = _.toNumber(region.split('-')[1]);
                    locationNames.push(_.head(_.filter(this.siteGroups, o=> o.id == regionId)).name)
                })
                _.each(cityIds.slice(0,3-locationNames.length), city=>{
                    let cityId = city.split('-')[2];
                    locationNames.push(_.head(_.filter(this.$store.state.cities, o=>o.code == cityId)).name)
                })
                _.each(siteIds.slice(0,3-locationNames.length), site=>{
                    let siteId = _.toNumber(site.split('-')[1]);
                    locationNames.push(_.head(_.filter(this.sites, o=> o.id == siteId)).originalName)
                })


                if((siteIds.length+regionIds.length)>3){
                    return locationNames.join(", ")+this.$t('and')+_.toString(regionIds.length+siteIds.length-3)+" "+this.$t('more');
                }else{
                    return locationNames.join(", ");
                }
            }
        },


        allDataTypes(){
            let filteredOptions = [];
            this.dataTypes.forEach(dataType => {
                filteredOptions.push({
                    value: dataType.id,
                    text:
                        this.$t(dataType.name) +
                        ` (${this.$t(_.get(
                            _.find(this.$store.state.units, {id: dataType.unit_id_1}),
                            'name'
                        ) || '')})`
                });
            });
            return filteredOptions;
        },

        // Configures the goal object when data type is changed
        configureItemOnDataTypeChange(val, item, isTempItem) {
            if (isTempItem) {
                this.bindTempItemToView();
            }
            return this.$nextTick().then(() => {
                let elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },
        reflectProcess(data){
            let processType = _.get(data,'process');
            data = _.omit(data, 'process');

            if(processType == 'update'){
                let rawItem = _.find(this.rawItems, {id: data.id});
                Object.assign(rawItem, data);
                this.bindItems(this.rawItems);
                this.listSiteGoals();
            }
            else if(processType == 'create'){
                this.rawItems.push(data);
                this.bindItems(this.rawItems);
                this.listSiteGoals();
            }
            else if(processType == 'delete'){
                this.rawItems = this.rawItems.filter(item => {
                    return item.id !== data.id;
                });
                this.bindItems(this.rawItems);
                this.listSiteGoals();
            }
            else if(processType == 'reset'){
                this.bindItems(this.rawItems);
            }
            else{
                this.listSiteGoals();
            }
        },

        insertRow(target) {
            this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'createGoal',
                    payload: {
                        title: "createGlobalGoal",
                        selectedGoal: {},
                        allSites: this.sitesWithGroups,
                        allDataTypes: this.allDataTypes()
                    }
                });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createGoal', target);
                this.$eventHub.$once(this.$store.state.modal.eventId, process => this.reflectProcess(process));
            });
        },

        cancelNewRow() {
            this.insertMode = false;
            this.bindTempItemToView();
        },

        makeRowEditable(target,goalId) {
            let goal = _.find(this.goals, {id: goalId});

            this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'updateGoal',
                    payload: {
                        title: "updateGlobalGoal",
                        selectedGoal: goal,
                        allSites: this.sitesWithGroups,
                        allDataTypes: this.allDataTypes()
                    }
                });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createGoal', target);
                this.$eventHub.$once(this.$store.state.modal.eventId, process => this.reflectProcess(process));
            });
        },

        resetWarning(item, key) {
            item[key].classes['is-invalid'] = false;
            item[key].hasWarn = false;
        },

        bindTempItemToView() {
            let tempItem = {
                startYear: {editedValue: 0},
                endYear: {editedValue: 0},
                direction: {editedValue: 0},
                dataTypeId: {editedValue: null},
                valueR: {editedValue: '0'},
                unitName: ''
            };

            for (let key in tempItem) {
                if (typeof tempItem[key] === 'object') {
                    tempItem[key].required = true;
                    tempItem[key].hasWarn = false; // toggles warning message
                    tempItem[key].lockR = false; // Number Field and Ratio Field calculates one another and it causes infinite loop. If value is true then Ratio field is locked for calculation.
                    tempItem[key].classes = {
                        'is-invalid': false,
                        'form-control': true
                    };
                    tempItem[key].warnMessage = this.$t('required');
                }
            }

            this.tempItem = tempItem;
        },

        // Prepare a goal object to use in dom
        prepareItem(item) {
            let configuredItem = {};
            var startDateInit;
            var endDateInit;
            startDateInit =
                item.start_date != null
                    ? item.start_date.substr(0, item.start_date.indexOf('-'))
                    : '-';
            endDateInit =
                item.end_date != null ? item.end_date.substr(0, item.end_date.indexOf('-')) : '-';

            configuredItem.editMode = false;
            configuredItem.lockR = false;

            configuredItem.id = item.id;
            configuredItem.parentSiteId = item.site_id;

            let siteKeys = this.createGroupedSitesKeys(item.sites);
            configuredItem.goalSites = {
                value: item.sites,
                editedValue: _.cloneDeep(siteKeys)
            }
            configuredItem.direction = {value: item.direction, editedValue: item.direction};
            let {name, unit_id_1} = _.find(this.dataTypes, {id: item.data_type_id});
            configuredItem.dataTypeId = {
                value: item.data_type_id,
                editedValue: item.data_type_id,
                name
            };
            configuredItem.unit = {
                id: unit_id_1,
                name: _.get(_.find(this.$store.state.units, {id: unit_id_1}), 'name')
            };
            let valueR = item.value_r ? item.value_r : '0';
            configuredItem.valueR = {
                value: globalFilters.parseNumber(valueR, 'float', this.locale),
                editedValue: globalFilters.parseNumber(valueR, 'float', this.locale)
            };
            configuredItem.startYear = {
                value: startDateInit,
                editedValue: startDateInit
            };
            configuredItem.endYear = {
                value: endDateInit,
                editedValue: endDateInit
            };

            for (let key in configuredItem) {
                // If a field editable it has to includes controller fields
                if (
                    typeof configuredItem[key] === 'object' &&
                    configuredItem[key].hasOwnProperty('value')
                ) {
                    configuredItem[key].classes = {
                        'is-invalid': false,
                        'form-control': true
                    };
                    configuredItem[key].hasWarn = false;
                    configuredItem[key].warnMessage = this.$t('required');
                }
            }

            return configuredItem;
        },

        // Bind goals object array to use in dom
        bindItems(goals) {
            this.goals = goals
                .filter(goal => _.find(this.dataTypes, {id: goal.data_type_id}))
                .map(this.prepareItem);
            return this.calculateLastColumnWidth();
        },

        listSiteGoals() {
            this.isLoaded = false;
            this.$Progress.start();
            return this.axios.get(`/globalGoals/`).then(({data}) => {
                this.units = data.unit;
                this.rawItems = data;
                this.bindItems(this.rawItems);
                this.isLoaded = true;
                return this.$Progress.finish();
            });
        },
        calculateLastColumnWidth() {
            return this.$nextTick().then(() => {
                let element = document.getElementById('goal-last-column');
                if (element) {
                    this.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },
        setFilteredGoals(){
            this.filteredGoals = _.filter(this.goals, o=>{
                return (_.toNumber(o.endYear.editedValue)>=this.yearSelection && _.toNumber(o.startYear.editedValue)<=this.yearSelection);
            });
        },
        init() {
            // @TODO: both for customer_id = 1 and 3 , we used hardcoded site id
            // in order to add global goal. This should be fixed by writing a backend service that will be called at init and will send main site of logged in customer.
            this.selectedSite =
                this.$store.state.user.customerId == 3
                    ? 1883
                    : this.gbId(this.$store.state.user.customerId) ? 1882 : null;
            this.dataTypes = this.$store.state.dataTypes;
            this.listSiteGoals();
        }
    },
    watch: {
        goals() {
            this.setFilteredGoals();
        },
        yearSelection() {
            this.setFilteredGoals();
        }
    },

    created() {
        this.init();
        window.addEventListener('resize', this.calculateLastColumnWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateLastColumnWidth);
    }
};
</script>

<style lang="scss" scoped>
.fadere-enter-active {
    opacity: 1;
    transition: opacity 0.6s ease;
}
.fadere-enter,
.fadere-leave-to,
.fadere-leave-active {
    opacity: 0;
}
th {
    min-width: 10em;
}
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
    "tr": {
    "title": "HEDEFLER",
    "locations": "Lokasyonlar",
    "dataTypeColumn": "Veri Tipi",
    "startYearColumn": "Baz Yıl",
    "endYearColumn": "Hedef Yıl",
    "goalTypeColumn": "Hedef Tipi",
    "goalRatioColumn": "Hedeflenen (%)",
    "currentSituation": "Mevcut Durumu Koruma",
    "decrease": "Azaltma",
    "raise": "Arttırma",
    "AllLocations": "Tüm Lokasyonlar",
    "more": "daha",
    "and": " ve ",
    "longProcessNotification": "Bu işlem biraz zaman alabilir, lütfen bekleyin. İşlem tamamlandığında tablo otomatik olarak yenilenecektir."
    
    },
    "en": {
    "title": "GOALS",
    "locations": "Locations",
    "dataTypeColumn": "Data Type",
    "startYearColumn": "Base Year",
    "endYearColumn": "Target Year",
    "goalTypeColumn": "Goal Type",
    "goalRatioColumn": "Targeted (%)",
    "currentSituation": "No Change",
    "decrease": "Decrease",
    "raise": "Raise",
    "AllLocations": "All Locations",
    "more": "more",
    "and": " and ",
    "longProcessNotification": "This process may take some time, please wait. When the process is complete, the table will be refreshed automatically."
    }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/AdminGoal.vue